<app-layout>
  <p-toast position="top-center" />
  <router-outlet></router-outlet>
</app-layout>
